import { Injectable } from '@angular/core';
import { EmployeeDataStore, Employee, MessageData } from '../models/employee-data';
import { Accord } from 'src/app/modules/shared/models/accord';
import { ActiveFilter } from '../models/filter';

@Injectable({
  providedIn: 'root'
})
export class EmployeeDataStoreService {

  accords: Accord[];
  employeeDataCached: EmployeeDataStore[];
  prevEmployeeDataCached: EmployeeDataStore[];
  filteredEmployees: Employee[] = [];
  activeFilter: ActiveFilter;
  Message: MessageData;

  constructor() {
    this.accords = [];
    this.employeeDataCached = [];
    this.prevEmployeeDataCached = [];
    this.activeFilter = {
      workType: 'All',
      pricingType: 'All',
      order: {
        by: 'MarginPer',
        dir: 'asc'
      },
    };
    this.Message = {
      Message:{
        Msg: '',
        Flag: false,
        LastUpdatedDate: ''
      }
    };
  }
}
